import { mutator } from 'satcheljs';
import { onHelpInfoChanged } from '../actions';
import { getAppStore } from '../store/store';

mutator(onHelpInfoChanged, msg => {
  getAppStore().helpInfo = msg.helpInfo;
});
